import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();
  const siteUrl = "https://fullscalemarketing.com.au";
  const siteName = "FullScale Marketing";

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Page Not Found | {siteName}</title>
        <meta name="description" content="Sorry, the page you're looking for doesn't exist. Return to FullScale Marketing's homepage — digital marketing for Australian trades and local service businesses." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={siteUrl} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`Page Not Found | ${siteName}`} />
        <meta property="og:description" content="Sorry, the page you're looking for doesn't exist. Return to our homepage." />
        <meta property="og:url" content={`${siteUrl}${location.pathname}`} />
        <meta property="og:site_name" content={siteName} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={`Page Not Found | ${siteName}`} />
        <meta name="twitter:description" content="Sorry, the page you're looking for doesn't exist. Return to our homepage." />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
